<template>
    <!--- Bank Information --->
    <div class="bank-main">
        <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold">{{$t('Bank Information')}}</h4>
        <div v-for="(bank, index) in bankInfo" :key="index" class="row mt-5">
            <div class="col-md-6">
                <b-form-group id="Bank" label-cols="3" label="Bank" label-for="Bank">
                    <b-form-select
                            v-model="bankInfo[index].bankId"
                            :options="bankList"
                            class="mb-3"
                            value-field="bankId"
                            text-field="bankEn"
                            @input="branchData(bankInfo[index].bankId, index)"
                            :state="getInputState(bankInfo[index].bankId)"
                    >
                        <option :value="null" selected>-- Select One --</option>
                    </b-form-select>
                    <b-form-invalid-feedback v-if="showError(bankInfo[index].bankId)">
                        Date of Birth is required.
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                        id="Branch"
                        label-cols="3"
                        label="Branch"
                        label-for="Branch"
                >
                    <b-form-select
                            v-model="bankInfo[index].branchId"
                            :options="branchLists[index] || []"
                            class="mb-3"
                            value-field="branchId"
                            text-field="branchNameEn"
                            :state="getInputState(bankInfo[index].branchId)"

                    >
                        <!--v-model="bankInfo[index].branchId"
                        :options="branchLists"
                        class="mb-3"
                        value-field="branchId"
                        text-field="branchNameEn"
                        disabled-field="notEnabled" :state="getInputState(bankInfo[index].branchId)"-->
                        <option value="" selected>-- Select One --</option>
                    </b-form-select>
                    <b-form-invalid-feedback v-if="showError(bankInfo[index].branchId)">
                        Date of Birth is required.
                    </b-form-invalid-feedback>

                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                        id="account_name"
                        label-cols="3"
                        label="Account Name"
                        label-for="account_name"
                >
                    <b-form-input
                            type="text"
                            v-model="bankInfo[index].bankAccNo"
                            class="form-control"
                            placeholder="Account Name"
                            name="account_name"
                            :state="getInputState(bankInfo[index].bankAccNo)"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="showError(bankInfo[index].bankAccNo)">
                        Bank Account Name is required.
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group
                        id="account_balance"
                        label-cols="3"
                        label="Account Balance"
                        label-for="account_balance"
                >
                    <b-form-input
                            type="text"
                            v-model="bankInfo[index].accBalance"
                            class="form-control"
                            placeholder="Account Balance"
                            name="account_balance"
                            :state="getInputState(bankInfo[index].accBalance)"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="showError(bankInfo[index].accBalance)">
                        Balance is required.
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="col-md-12 text-center mb-4" v-if="bankInfo.length > 1">
                <button @click="removeBank(index)" class="text-white btn btn-danger btn-md">
                    <span>REMOVE &nbsp; <font-awesome-icon icon="minus" class="modal-icon text-white"/></span>
                </button>
            </div>
        </div>
        <div class="text-center mb-4">
            <button @click="addBank" class="btn btn-success btn-md text-white">
                <span><font-awesome-icon icon="plus" class="modal-icon text-white"/> &nbsp;ADD BANK</span>
            </button>
        </div>
    </div>
    <!--- Bank Info End --->

    <!--- Wealth Info Start --->
    <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold">Wealth Information</h4>
    <div v-for="(wealth, index) in wealthInfo" :key="index" class="row mt-5">
        <div class="col-md-6">
            <b-form-group
                    id="wealth"
                    label-cols="3"
                    label="Wealth"
                    label-for="Wealth"
            >
                <b-form-select
                        v-model="wealthInfo[index].wealthId"
                        :options="wealthInfoOption"
                        class="mb-3"
                        @input="wealthDocumentTypeGet(wealthInfo[index].wealthId, index)"
                        value-field="wealthId"
                        text-field="wealth"
                        disabled-field="notEnabled"
                        :state="getInputState(wealthInfo[index].wealthId)"
                >
                    <option value="" selected>-- Select One --</option>
                </b-form-select>
                <b-form-invalid-feedback v-if="showError(wealthInfo[index].wealthId)">
                    Wealth is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <!-- Document -->
        <div class="col-md-6">
            <b-form-group label="Document Type" label-cols="3" label-for="document">
                <b-form-select
                        v-model="wealthInfo[index].documentTypeId"
                        :options="wealthDocsTypeOption[index] || []"
                        placeholder="Document Type"
                        value-field="documentTypeId"
                        text-field="documentType"
                        type="text"
                        :state="getInputState(wealthInfo[index].documentTypeId)"
                        class="form-control">
                    <option value="" selected>-- Select One --</option>
                </b-form-select>
                <b-form-invalid-feedback v-if="showError(wealthInfo[index].documentTypeId)">
                    Document type is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="wealthInfo.documentTypeId">
            <b-form-group
                    label="Document Attachment"
                    label-for="document_attachment"
                    class="document_attachment"
                    label-cols="3">
                <div class="d-flex align-items-center">
                    <input
                            type="file"
                            ref="fileinput"
                            name="document_attachment"
                            @change="documentFileAttach(index, $event)"
                            class="form-control form-control-md me-2"
                            style="width: 90%;"/>
                    <button
                            class="btn btn-success"
                            @click="downloadFile(wealthInfo[index].documentPaperUrl, 'Wealth Document')"
                            v-if="wealthInfo[index].documentPaperUrl"
                            style="white-space: nowrap;">
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>

                </div>

                <span style="font-size: 10px" class="text-danger">Only PDF JPEG PNG</span>
            </b-form-group>
        </div>

        <div class="col-md-6" v-if="wealthInfo[index].wealthId">
            <b-form-group
                    :label="dynamicLabels[index]"
                    label-cols="3"
                    label-for="amount"
            >
                <b-form-input
                        v-model="wealthInfo[index].amount"
                        :placeholder="dynamicLabels[index]"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group label="Location" label-cols="3" label-for="location">
                <b-form-input
                        v-model="wealthInfo[index].location"
                        placeholder="Location"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group label="Note" label-cols="3" label-for="note">
                <b-form-input
                        v-model="wealthInfo[index].note"
                        placeholder="Note"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="text-center mb-4" v-if="this.wealthInfo.length > 1">
            <button @click="removeWealth" class="text-white btn btn-danger btn-md">
                <span>REMOVE&nbsp; <font-awesome-icon icon="minus" class="modal-icon text-white"/></span>
            </button>
        </div>
    </div>
    <div class="text-center mb-4">
        <button @click="addWealth" class="text-white btn btn-success btn-md">
            <span><font-awesome-icon icon="plus" class="modal-icon text-white"/> &nbsp;ADD WEALTH</span>
        </button>
    </div>
    <!--- Wealth Info End --->

    <!--- Accounts Receivable Info Start --->
    <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold">Accounts Receivable</h4>
    <div class="row mt-5" v-for="(receivable, index) in receivableInfo" :key="index">
        <div class="col-md-6">
            <b-form-group
                    label="Receivable Amount"
                    label-cols="4"
                    label-for="receivable"
            >
                <b-form-input
                        v-model="receivableInfo[index].receivableAmount"
                        placeholder="Receivable Amount"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    label="Receivable Person"
                    label-cols="4"
                    label-for="receivable_person"
            >
                <b-form-input
                        v-model="receivableInfo[index].receivablePerson"
                        placeholder="Receivable Person"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    label="Receivable Person Mobile"
                    label-cols="4"
                    label-for="receivable_person_mobile"
            >
                <b-form-input
                        v-model="receivableInfo[index].receivablePersonMobile"
                        placeholder="Receivable Person Mobile"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-12 text-center" v-if="receivableInfo.length > 1">
            <button class="btn btn-danger" @click="removeReceivableInfo(index)">REMOVE</button>
        </div>
    </div>
    <div class="text-center">
        <button class="btn btn-success fa-lg mb-3 mt-3 " @click="addReceivableInfo">
            <span> <font-awesome-icon icon="plus" class="modal-icon text-white"/>&nbsp;ADD </span>
        </button>
    </div>
    <!--- Accounts Receivable Info End  --->

    <!--- Accounts Payable Info Start --->
    <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold mt-4 mb-5">Accounts Payable</h4>
    <div class="row" v-for="(payable, index) in payableInfo" :key="index">
        <div class="col-md-6">
            <b-form-group label="Payable Amount" label-cols="4" label-for="payable_amount">
                <b-form-input
                        name="payable_amount"
                        v-model="payableInfo[index].payableAmount"
                        placeholder="Payable Amount"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group label="Payable Person" label-cols="4" label-for="payable_person">
                <b-form-input
                        name="payable_person"
                        v-model="payableInfo[index].payablePerson"
                        placeholder="Payable Person"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group label="Payable Person Mobile" label-cols="4" label-for="payable_person_mobile">
                <b-form-input
                        name="payable_person_mobile"
                        v-model="payableInfo[index].payablePersonMobile"
                        placeholder="Payable Person Mobile"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-12 text-center mb-4" v-if="payableInfo.length > 1">
            <button class="btn btn-danger text-white" @click="removePayableInfo(index)">
                <span>REMOVE<font-awesome-icon icon="minus" class="modal-icon text-white"/></span>
            </button>
        </div>
    </div>
    <div class="text-center">
        <button class="btn btn-success text-white" @click="addPayableInfo">
            <span><font-awesome-icon icon="plus" class="modal-icon text-white"/>ADD</span>
        </button>
    </div>
    <!--- Accounts Payable Info End --->

</template>

<script>
    import apiRepository, {getMedia} from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";

    export default {
        name: "ProfileStepFive",
        props: ["formData"],
        data() {
            return {
                status: "",
                // bankInfo: {...this.formData},
                allCountry: [],
                bankList: [],
                dynamicLabels: [],
                branchLists: {},
                wealthInfoOption: [],
                wealthDocsTypeOption: {},
                bankInfo: this.formData.bankInfo && this.formData.bankInfo.length ? this.formData.bankInfo : [
                    {
                        userBankInfoId: "",
                        userId: "",
                        bankId: "",
                        branchId: "",
                        bankAccNo: "",
                        accBalance: ""
                    }
                ],
                wealthInfo: this.formData.wealthInfo && this.formData.wealthInfo.length ? this.formData.wealthInfo : [
                    {
                        userId:'',
                        wealthId:'',
                        documentTypeId:'',
                        documentPaperUrl:'',
                        amount:'',
                        location:'',
                        note:'',
                        documentFile:''
                    }
                ],
                receivableInfo: this.formData.receivableInfo && this.formData.receivableInfo.length ? this.formData.receivableInfo : [
                    {
                        recId:'',
                        userId:'',
                        receivableAmount:'',
                        receivablePerson:'',
                        receivablePersonMobile:'',
                    }
                ],
                payableInfo: this.formData.payableInfo && this.formData.payableInfo.length ? this.formData.payableInfo : [
                    {
                        payId: "",
                        userId: "",
                        payableAmount: "",
                        payablePerson: "",
                        payablePersonMobile: ""
                    }
                ]
            };

        },
        mounted() {
            this.countryData();
            this.bankData();
            this.wealthInfoGet();
            this.fetchProfileStepFive();
        },
        watch: {
            bankInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-bank-info", newVal);
                    // this.$emit("update:formData", {...this.formData, bankInfo: newVal});
                }
            },
            wealthInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-wealth-info", newVal);
                }
            },
            receivableInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-receivable-info", newVal);
                }
            },
            payableInfo: {
                deep: true,
                handler(newVal) {
                    this.$emit("update-payable-info", newVal);
                }
            },

        },
        methods: {
            getInputState(value) {
                if (value === '') return false;
                if (typeof value === 'string') return value.trim().length > 0;
                return !!value;
            },
            showError(value) {
                return value === '' || (typeof value === 'string' && value.trim() === '');
            },
            countryData() {
                apiRepository.getCountry().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.allCountry = response.data;
                    }
                });
            },
            bankData() {
                apiRepository.getBankList().then((response) => {
                    if (response.data) {
                        this.bankList = response.data
                    } else {
                        console.error("Invalid response structure:", response.data);
                    }
                })
                    .catch((error) => {
                        console.error("Error fetching marital data:", error);
                    });
            },

            branchData(bankId, index) {
                apiRepository.getBranchList(bankId).then((response) => {
                    if (response) {
                        this.branchLists[index] = response.data;
                    } else {
                        console.error("Invalid response structure");
                        this.branchLists[index] = [];
                    }
                }).catch((e) => {
                        console.error("Error fetching branch data:", e);
                        this.branchLists[index] = [];
                    });
            },

            wealthInfoGet() {
                const lang = 'en'
                apiRepository.getWealthData(lang).then((response) => {
                    if (response) {
                        this.wealthInfoOption = response.data;
                    } else {
                        console.error('Data Not Found!!')
                    }
                })
            },
            wealthDocumentTypeGet(data, index) {
                apiRepository.getWealthDocumentType(data).then((response) => {
                    if (response) {
                        this.wealthDocsTypeOption[index] = response.data;
                        this.dynamicLabels[index] = response.data[0]?.amountLabel || '';
                    } else {
                        this.wealthDocsTypeOption[index] = [];
                        this.dynamicLabels[index] = '';
                        console.error('Data Not Found!!')
                    }
                })
            },
            documentFileAttach(index, event) {
                const file = event.target.files[0];
                console.log(file)
                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.wealthInfo[index].documentFile = reader.result;
                    };
                }
            },
            addBank() {
                this.bankInfo.push({
                    userBankInfoId: "",
                    userId: "",
                    bankId: "",
                    branchId: "",
                    bankAccNo: "",
                    accBalance: ""
                });
            },
            removeBank(index) {
                console.log('index value', index)
                if (this.bankInfo.length > 1) {
                    this.bankInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last bank entry!");
                }
            },
            addWealth() {
                this.wealthInfo.push({
                    userId: "",
                    wealthId: "",
                    documentTypeId: "",
                    documentPaperUrl: "",
                    amount: "",
                    location: "",
                    note: "",
                    documentFile: ""
                });
            },
            removeWealth(index) {
                if (this.wealthInfo.length > 1) {
                    this.wealthInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last wealth entry!");
                }
            },
            addPayableInfo() {
                this.payableInfo.push({
                    payId: "",
                    userId: "",
                    payableAmount: "",
                    payablePerson: "",
                    payablePersonMobile: ""
                });
            },
            removePayableInfo(index) {
                if (this.payableInfo.length > 1) {
                    this.payableInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last payable entry!");
                }
            },
            addReceivableInfo() {
                this.receivableInfo.push({
                    recId: "",
                    userId: "",
                    receivableAmount: "",
                    receivablePerson: "",
                    receivablePersonMobile: ""
                });
            },
            removeReceivableInfo(index) {
                if (this.receivableInfo.length > 1) {
                    this.receivableInfo.splice(index, 1);
                } else {
                    alert("You can't remove the last Receivable entry!");
                }
            },
            fetchProfileStepFive() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response) {
                            this.bankInfo = response.data.bankInfo || [];
                            this.branchLists = {};

                            this.bankInfo.forEach((item, index) => {
                                if (item.bankId) {
                                    this.branchData(item.bankId, index);
                                } else {
                                    this.branchLists[index] = [];
                                }
                            });

                            this.wealthInfo = response.data.wealthInfo || [];
                            this.wealthDocsTypeOption = {};

                            this.wealthInfo.forEach((item, index) => {
                                if (item.wealthId) {
                                    this.wealthDocumentTypeGet(item.wealthId, index);
                                } else {
                                    this.wealthDocsTypeOption[index] = [];
                                }
                            });

                            this.receivableInfo = response.data.receivableInfo;
                            this.payableInfo = response.data.payableInfo
                        } else {
                            console.error('Data not Found!!')
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }
            },
            async downloadFile(url, filename) {
                // Normalize some MIME subtype extensions (optional)
                const specialMimeExtMap = {
                    jpeg: "jpg",
                    msword: "doc",
                    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
                    "vnd.ms-excel": "xls",
                    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
                    "vnd.ms-powerpoint": "ppt",
                    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
                    "x-7z-compressed": "7z"
                    // Add more if needed
                };

                try {
                    const response = await fetch(getMedia() + url);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
                    }

                    const data = await response.json();

                    // Decode base64 content
                    const byteCharacters = atob(data.content);
                    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                    const byteArray = new Uint8Array(byteNumbers);

                    // Determine correct content type
                    let contentType = data.contentType || "";
                    let fileExt = "";

                    if (contentType.includes('/')) {
                        // Extract subtype after '/'
                        fileExt = contentType.split('/')[1].split(';')[0].trim().toLowerCase();

                        // Normalize extension if needed
                        if (fileExt in specialMimeExtMap) {
                            fileExt = specialMimeExtMap[fileExt];
                        }
                    }

                    // If filename doesn't already end with this extension, append it
                    if (fileExt && !filename.toLowerCase().endsWith(`.${fileExt}`)) {
                        filename += `.${fileExt}`;
                    }

                    // Create Blob
                    const blob = new Blob([byteArray], { type: contentType || "application/octet-stream" });

                    // Trigger download
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(blobUrl);

                } catch (error) {
                    console.error("Download failed:", error);
                }
            },

        },
    };
</script>

<style scoped>
    input[readonly] {
        background-color: #eaeaea; /* Light gray background */
        cursor: not-allowed; /* Show "not-allowed" cursor */
    }
</style>
